import React from 'react';

const MarketPanelPreMarketNews = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Pre Market News</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="pre-market-news">
            <thead>
              <tr>
                <th>Stock Name</th>
                <th>News</th>
                <th>Impact</th>
                <th>Time</th>
                <th>Source</th>
                <th>Previous Close</th>
                <th>Pre-Market Price</th>
                <th>Change</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.stock_name || '-'}</td>
                    <td>{item.news || '-'}</td>
                    <td>{item.impact || '-'}</td>
                    <td>{item.time || '-'}</td>
                    <td>{item.source || '-'}</td>
                    <td>{item.previous_close || '-'}</td>
                    <td>{item.pre_market_price || '-'}</td>
                    <td>{item.change || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelPreMarketNews;